import { createAsyncThunk } from '@reduxjs/toolkit';
import { axiosWithAuth } from '@/services/axios';

// Add to Wishlist Thunk
export const addWishlist = createAsyncThunk(
  'wishlist/addWishlist',
  async (productId, { getState, rejectWithValue }) => {
    const { isLoggedIn } = getState().auth;

    if (!isLoggedIn) {
      return [];
    }

    try {
      const request = { items: [{ product_id: productId }] };
      const response = await axiosWithAuth().post(
        `/api/order/wishlist`,
        request,
      );

      const data = response?.data;

      if (!data?.status || !data?.data) {
        throw new Error('Invalid response for wishlist');
      }
      return data?.status === 'success';
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.message);
    }
  },
);

// Get Wishlist Thunk
export const getWishlist = createAsyncThunk(
  'wishlist/getWishlist',
  async (_, { getState, rejectWithValue }) => {
    const { isLoggedIn } = getState().auth;

    if (!isLoggedIn) {
      return [];
    }

    try {
      const response = await axiosWithAuth().get(`/api/order/wishlist`);

      const data = response?.data;

      if (!data?.status || !data?.data) {
        throw new Error('Invalid wishlist data');
      }
      return data?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.message);
    }
  },
);

// Remove from Wishlist Thunk
export const removeFromWishlist = createAsyncThunk(
  'wishlist/removeFromWishlist',
  async (productId, { getState, rejectWithValue }) => {
    const { items: wishlist } = getState().wishlist;
    const { isLoggedIn } = getState().auth;

    if (!isLoggedIn) {
      return [];
    }

    try {
      const response = await axiosWithAuth().delete(
        `/api/order/wishlist/${productId}`,
      );

      const data = response?.data;

      if (!data?.status || !data?.data) {
        throw new Error('Invalid response for wishlist');
      }

      if (data?.status === 'success') {
        return wishlist?.length > 0
          ? wishlist?.filter((item) => item.id !== productId)
          : [];
      }
      return null;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.message);
    }
  },
);

// Remove All Items From Wishlist Thunk
export const removeAllFromWishlist = createAsyncThunk(
  'wishlist/removeAllFromWishlist',
  async (_, { getState, rejectWithValue }) => {
    const { isLoggedIn } = getState().auth;

    if (!isLoggedIn) {
      return [];
    }

    try {
      const response = await axiosWithAuth().delete(`/api/order/wishlist/all`);

      const data = response?.data;

      if (!data?.status || !data?.data) {
        throw new Error('Invalid response for wishlist');
      }

      if (data?.status === 'success') {
        return [];
      }
      return null;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || error?.message);
    }
  },
);
